import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/api/query-keys'
import { CLIKART_PLACEMENT_CHANGED_EVENT } from '@/lib/clikart/clikart-placement-session'
import {
  flushScheduledAlbumPhotosRefresh,
  scheduleAlbumPhotosRefresh,
} from '@/lib/photos/schedule-album-photos-refresh'

/**
 * Re-reads the book's placed ClikArt (debounced) after the live canvas changes the session's
 * placements, so a scan that finished in the meantime is picked up. It re-reads only the small
 * placed-ids query — never the ~21MB catalog, whose `placedFlag` no longer drives the badge once
 * the book's scan has been applied. Mounted once at the editor level so it keeps running when the
 * ClikArt panel is closed.
 */
export function useClikArtPlacementRefresh() {
  const queryClient = useQueryClient()

  useEffect(() => {
    const queryKey = queryKeys.clikArt.placedIds()
    const onChanged = () => scheduleAlbumPhotosRefresh(queryClient, queryKey)

    window.addEventListener(CLIKART_PLACEMENT_CHANGED_EVENT, onChanged)
    return () => {
      window.removeEventListener(CLIKART_PLACEMENT_CHANGED_EVENT, onChanged)
      flushScheduledAlbumPhotosRefresh(queryKey)
    }
  }, [queryClient])
}
